<div class="tableContainer">
  <table class="filterPageTable">
    <caption style="display: none">
      Texto prueba
    </caption>
    <thead
      [ngClass]="
        options.label
          ? 'filterPageTableHeadWithoutFilters'
          : 'filterPageTableHead'
      "
    >
      <tr class="row" [ngStyle]="options?.style">
        <th
          *ngIf="options && options.showCheckbox"
          class="col xxsColCheckbox checkboxCol"
        >
          <div class="colCheckboxHeadContainer">
            <input
              type="checkbox"
              id="cbox1"
              value="checkbox"
              style="cursor: pointer !important"
              [checked]="checkedAll"
              (click)="selectElement('all')"
            />
          </div>
        </th>
        <th class="checkboxCol" *ngIf="options && options.arrowUpDown"></th>
        <th class="checkboxCol" *ngIf="options && options.arrowUpDown"></th>
        <th
          class="{{ item.labelHeader ? 'sorted' : '' }}  col {{ item.size }}"
          [ngStyle]="item.style"
          *ngFor="let item of tableList"
        >
          <ng-container *ngIf="item.labelHeader">
            <span *ngIf="options && options.label">{{ item.labelHeader }}</span>
            <div class="colSorterContainer">
              <a
                (click)="onChangeOrder(item.order, true)"
                *ngIf="!item.hideOrderButton"
              >
                <em
                  *ngIf="
                    options &&
                    options.orderColumns &&
                    item.labelHeader != '' &&
                    item.labelHeader != 'empty'
                  "
                  class="sortIcon fas fa-sort-up"
                ></em>
              </a>
              <a
                style="margin-left: 6px"
                (click)="onChangeOrder(item.order, false)"
                *ngIf="!item.hideOrderButton"
              >
                <em
                  *ngIf="
                    options &&
                    options.orderColumns &&
                    item.labelHeader != '' &&
                    item.labelHeader != 'empty'
                  "
                  class="sortIcon fas fa-sort-down"
                ></em>
              </a>
            </div>
          </ng-container>
        </th>
        <th class="col xsColButton" *ngIf="options && options.filtersButton">
          <div class="smallHeaderButtons">
            <div class="buttonContainer eraserContainer">
              <button
                class="submitSearchButton"
                *ngIf="showFilterButtons"
                (click)="headerButtonsAction('erase')"
                type="button"
              >
                <em class="fas fa-eraser"></em>
              </button>
            </div>

            <div class="buttonContainer searchContainer">
              <button
                class="submitSearchButton"
                *ngIf="showFilterButtons"
                (click)="headerButtonsAction('search')"
                type="button"
              >
                <em class="fa-search fas"></em>
              </button>
            </div>

            <div class="buttonContainer filterContainer">
              <button
                class="submitSearchButton"
                (click)="headerButtonsAction('toggleFilters')"
                type="button"
              >
                <em class="fas fa-filter"></em>
              </button>
            </div>
          </div>
        </th>
        <th
          class="col xsColButton"
          *ngIf="options && !options.hideEditButton && !options.filtersButton"
        >
          <!--Espacio para cuando no se quieren mostrar los botones de filtros pero si el de edición, así se cuadra bien la tabla-->
        </th>
      </tr>
    </thead>

    <tbody class="filterPageTableBody">
      <div class="trContainer">
        <ng-container *ngFor="let element of elementList; let i = index">
          <tr
            class=" backgroundblack row {{ i % 2 === 0 ? 'even' : 'odd' }}"
            [ngStyle]="options?.style"
          >
            <td
              *ngIf="options && options.showCheckbox"
              class="col xxsColCheckbox checkboxCol tableCheckbox"
            >
              <div class="colCheckboxContainer">
                <input
                  type="checkbox"
                  id="cbox1"
                  value="checkbox"
                  style="cursor: pointer !important"
                  [checked]="isChecked(element[routing.id])"
                  (click)="selectElement(element[routing.id])"
                />
              </div>
            </td>
            <td *ngIf="options && options.arrowUpDown" class="col checkboxCol">
              <button
                class="arrowUpDown"
                (click)="moveUp(element[routing.id])"
                type="button"
              >
                <em class="fas fa-arrow-up"></em>
              </button>
            </td>
            <td *ngIf="options && options.arrowUpDown" class="col checkboxCol">
              <button
                class="arrowUpDown"
                (click)="moveDown(element[routing.id])"
                type="button"
              >
                <em class="fas fa-arrow-down"></em>
              </button>
            </td>
            <td
              *ngFor="let col of tableList"
              class="overflow col genericElement {{ col.size }}"
              [ngClass]="col.note || col.firma ? 'tableButtonContainer' : ''"
              [ngStyle]="{ display: col.labelHeader == '' ? 'none' : '' }"
              [ngStyle]="col.style"
            >
              <ng-container *ngIf="!col.special">
                <div class="labelTextContainer">
                  <p
                    data-toggle="tooltip"
                    data-placement="top"
                    title="{{ element[col.objectKey] }}"
                  >
                  <span *ngIf="col.objectKey == 'id' && esMovil else pcTable" class="linkSolicitud" (click)="goToEdit(element[routing.id])">{{ element[col.objectKey] }}</span>
                  <ng-template #pcTable>{{ element[col.objectKey] }}</ng-template>
                  </p>
                </div>
              </ng-container>
              <!-- Caso para botones especiales -->
              <ng-container *ngIf="col.download">
                <div
                  class="colButtonContainer tableButton editButton elementOfListButton"
                >
                  <button
                    (click)="download(element)"
                    class="buttonDownload adjustPosInTable"
                    type="button"
                  >
                    <em class="fas fa-file-download"> </em>
                  </button>
                </div>
              </ng-container>
              <ng-container *ngIf="col.firma && element[col.objectKey]">
                <div
                  class="colButtonContainer tableButton editButton elementOfListButton"
                >
                  <button
                    data-placement="top"
                    (click)="getHistoryPreviousList(element.id)"
                    class="adjustPosInTable"
                    type="button"
                  >
                    <em class="fas fa-download"> </em>
                  </button>
                </div>
              </ng-container>
              <ng-container *ngIf="col.note && element[col.objectKey]">
                <div
                  class="colButtonContainer tableButton editButton elementOfListButton"
                >
                  <button
                    data-toggle="tooltip"
                    data-placement="top"
                    title="{{ element[col.objectKey] }}"
                    class="adjustPosInTable"
                    type="button"
                  >
                    <em class="fas fa-file-invoice"> </em>
                  </button>
                </div>
              </ng-container>
              <ng-container *ngIf="col.file && element[col.objectKey]">
                <div
                  class="colButtonContainer tableButton editButton elementOfListButton"
                >
                  <button
                    data-placement="top"
                    (click)="getHistoryPreviousList(element.id)"
                    class="buttonDownload buttonConsultaBuzonDownload adjustPosInTable"
                    type="button"
                  >
                    <em class="fas fa-download"></em>
                  </button>
                </div>
              </ng-container>
            </td>

            <td
              class="col xsColButton tableButtonContainer editButtonCol"
              *ngIf="
                (options && !options.hideEditButton) ||
                (options && options.editButtonEmpty)
              "
            >
              <div
                class="colButtonContainer tableButton editButton"
                *ngIf="!options.editButtonEmpty"
              >
                <button type="button" (click)="goToEdit(element[routing.id])">
                  <em class="fa-user-edit fas"></em>
                </button>
              </div>
            </td>
          </tr>
        </ng-container>
      </div>
    </tbody>
    <div class="tableFooter" [ngStyle]="options?.style">
      <div *ngIf="!mastertable" class="botonera">
        <button
          type="button"
          [disabled]="filterParams.page == 0"
          (click)="setPage(0)"
        >
          <!-- Primera -->

          <em class="fas fa-angle-double-left"></em>
        </button>

        <button
          type="button"
          [disabled]="filterParams.page == 0"
          (click)="setPage(filterParams.page - 1)"
        >
          <!-- Anterior -->

          <em class="fas fa-angle-left"></em>
        </button>

        <button type="button">
          <label>{{ filterParams.page + 1 }} </label>
        </button>

        <button
          type="button"
          [disabled]="numPages == filterParams.page + 1"
          (click)="setPage(filterParams.page + 1)"
        >
          <!-- Siguiente -->

          <em class="fas fa-angle-right"></em>
        </button>

        <button
          type="button"
          [disabled]="numPages == filterParams.page + 1"
          (click)="setPage(numPages - 1)"
        >
          <!-- Ultima -->

          <em class="fas fa-angle-double-right"></em>
        </button>
      </div>

      <div *ngIf="mastertable" class="botonera">
        <button
          type="button"
          [disabled]="filterParams.page - 1 <= 0"
          (click)="setPage(1)"
        >
          <em class="fas fa-angle-double-left"></em>

          <!--Primera-->
        </button>

        <button
          type="button"
          [disabled]="filterParams.page - 1 <= 0"
          (click)="setPage(filterParams.page - 1)"
        >
          <em class="fas fa-angle-left"></em>

          <!--Anterior-->
        </button>

        <button type="button">
          <label>
            {{ filterParams.page }}
          </label>
        </button>

        <button
          type="button"
          [disabled]="numPages == filterParams.page"
          (click)="setPage(filterParams.page + 1)"
        >
          <em class="fas fa-angle-right"></em>

          <!--Siguiente-->
        </button>

        <button
          type="button"
          [disabled]="numPages == filterParams.page"
          (click)="setPage(numPages)"
        >
          <em class="fas fa-angle-double-right"></em>

          <!--Ultima-->
        </button>
      </div>

      <div
        class="addDeleteButtonsTable"
        *ngIf="(options && options.create) || (options && options.delete)"
      >
        <div class="tableButtonContainer margin1">
          <div class="addButton" *ngIf="options && options.create">
            <button
              class="submitButton reduceSize"
              type="button"
              (click)="goToCreate()"
            >
              <div class="iconButtonContainer">
                <em class="far fa-plus-square"></em>
              </div>
            </button>
          </div>
        </div>
        <swal
          #deleteSwal
          html="<strong>¿Estás seguro de borrarlo?</strong>"
          icon="warning"
          [showCancelButton]="true"
          [swalOptions]="{
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            allowEscapeKey: false,
            allowOutsideClick: false
          }"
          [focusCancel]="true"
        >
        </swal>

        <div class="tableButtonContainer margin1">
          <div class="addButton" *ngIf="options && options.delete">
            <button class="reduceSize" type="button" (click)="remove()">
              <div class="iconButtonContainer">
                <em class="far fa-trash-alt"></em>
              </div>
            </button>
          </div>
        </div>
        <div class="tableButtonContainer margin1">
          <div
            class="addButton tableButton"
            *ngIf="options && options.downloadReport"
          >
            <button
              class="submitButton"
              type="button"
              (click)="downloadReport()"
            >
              <div class="iconButtonContainer">
                <em class="fas fa-file-download"> </em>
              </div>
            </button>
          </div>
        </div>
      </div>
      <div class="infoPagesTable" *ngIf="filterParams && !mastertable">
        <p>
          Página: {{ filterParams["page"] + 1 }} /
          {{ numPages }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Registros mostrados: {{ numElements }} / {{ totalElements }}
        </p>
      </div>
      <div class="infoPagesTable" *ngIf="filterParams && mastertable">
        <p>
          Página: {{ filterParams["page"] }} /
          {{ numPages }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Registros mostrados: {{ numElements }} / {{ totalElements }}
        </p>
      </div>
    </div>
  </table>
</div>
